import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../environments/environment';
import { Observable } from 'rxjs';
import { JumpAuthRequestBody, JumpAuthResponse, JumpProjectAppsResponse } from 'core';

@Injectable({
  providedIn: 'root'
})
export class JumpAuthService {
  baseUrl = environment.apiEndpoint + '/JUMP/';


  constructor(private http: HttpClient) { }

  getJumpToken(body: JumpAuthRequestBody): Observable<JumpAuthResponse> {
    return this.http.post<JumpAuthResponse>(this.baseUrl + "auth", body);
  }

  getProjectApps(projectId: string, jst: string, jpt: string): Observable<Array<JumpProjectAppsResponse>> {
    return this.http.get<Array<JumpProjectAppsResponse>>(this.baseUrl + "user/project-apps/" + projectId, {
      headers: new HttpHeaders({
        jst: jst,
        jpt: jpt
      })
    });
  }

  getJumpApiUrl(): string {
    return environment.jumpApiUrl;
  }

  getJumpAppUrl(): string {
    return environment.jumpAppUrl;
  }
}
